const sidebar = {
  'sidebar-pages': 'Pages',
  'sidebar-other': 'Other',
  'sidebar-notifications': 'Notifications',
  'sidebar-rbac': 'RBAC',
  'sidebar-pages-rbac-users': 'Users',
  'sidebar-featured': 'Featured',
  'sidebar-featured-news': 'News',
  'sidebar-featured-old-news': 'Old news',
  'sidebar-featured-news-icons': 'Icons',
  'sidebar-featured-news-dictionary': 'Dictionary',
  'sidebar-featured-news-dictionary-btn': 'Dictionary button',
  'sidebar-featured-daily': 'Daily',
  'sidebar-featured-editors-choice': "Editor's choice",
  'sidebar-featured-external-promo': 'External promo',
  'sidebar-pages-push-icons': 'Push Icons',
  'sidebar-pages-deeplinks': 'Deeplinks',
  'sidebar-pages-reset-static-content': 'Reset static data',
  'sidebar-pages-filter-constructors': 'Filter builder',
  'sidebar-pages-filters': 'Filters',
  'sidebar-pages-filters-groups': 'Filter groups',
  'sidebar-pages-filters-collections': 'Filter collections',
  'sidebar-pages-popups': 'Popups',
  'sidebar-pages-events': 'Events',
  'sidebar-pages-stickers': 'Stickers',
  'sidebar-pages-local-notifications': 'Local notifications',
  'sidebar-pages-push-notifications': 'Push notifications',
  'sidebar-pages-push-notifications-schedule': 'Schedule',
  'sidebar-pages-blank-page': 'Blank Page',
  'sidebar-pages-error': 'Error Pages',
  'sidebar-view-profile': 'View Profile',
  'sidebar-translations': 'Translations',
  'sidebar-content': 'Content',
  'sidebar-content-images': 'Images',
  'sidebar-content-reserve-statistics': 'Reserve statistics',
  'sidebar-content-images-search-similar': 'Advanced search',
  'sidebar-content-categories': 'Categories',
  'sidebar-content-achievements': 'Achievements',
  'sidebar-content-collections': 'Collections',
  'sidebar-content-feeds': 'Feeds',
  'sidebar-content-bonuses': 'Bonuses',
  'sidebar-template-constructors': 'Template builder',
  'sidebar-templates': 'Templates',
  'sidebar-templates-visualizations': 'Visualization data',
  'sidebar-presets': 'Presets',
  'sidebar-general-list': 'List',
  'sidebar-general-priority': 'Priority',
  'sidebar-general-logs': 'Logs',
  'sidebar-content-feeds-released': 'Released',
  'sidebar-content-feeds-archived': 'Archive',
  'sidebar-content-feeds-planning': 'Planning',
  'sidebar-content-feeds-trashed': 'Trash',
};

export default sidebar;
